<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('EMAIL_CHANGE.HEADER') }}
    </h1>
    <p>
      {{ this.$i18n.t('EMAIL_CHANGE.INFO') }}
    </p>
    <embedded-spinner :show="!subscriberData" />
    <input-box
      v-if="subscriberData"
      id="oldEmailField"
      ref="oldEmailField"
      :label="this.$i18n.t('EMAIL_CHANGE.OLD_EMAIL')"
      name="oldEmailField"
      :initial-value="oldEmail"
      :disabled="true"
    />
    <validated-input-box
      id="newEmailField"
      ref="newEmailField"
      :validation-reg-exp="emailRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.EMAIL_ERROR')"
      :label="this.$i18n.t('KUZO_REGISTRATION.EMAIL')"
      name="newEmailField"
    />
    <validated-input-box
      id="repeatEmailField"
      ref="repeatEmailField"
      :label="this.$i18n.t('EMAIL_CHANGE.CONFIRM_EMAIL')"
      name="repeatEmailField"
      validation-reg-exp="^.*$"
      :validation-error-message="this.$i18n.t('EMAIL_CHANGE.EMAILS_DONT_MATCH')"
    />
    <submit-button
      id="emailChangeSubmitButton"
      :label="this.$i18n.t('EMAIL_CHANGE.SUBMIT')"
      :on-click="submitForm"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';

const RESP_OK = 0;
const RESP_VALIDATION_ERROR = 1;
const RESP_OTHER_ERROR = 9999;

export default {
  name: 'EmailChange',
  components: {  },
  data: function() {
    return {
      inProgress: false,
      emailsMatch: true,
      isMounted: false,
    };
  },
  computed: {
    emailRegex: function() {
      return Regex.EMAIL;
    },
    newEmail: function() {
      if(this.isMounted) {
        return this.$refs.newEmailField.textValue;
      } else {
        return ".*";
      }
    },
    subscriberData: function() {
      return this.$store.getters['subscriber/subscriberData'];
    },
    oldEmail: function() {
      if (this.subscriberData) {
        return this.subscriberData.email;
      } else {
        return null;
      }
    },
  },
  watch: {
    newEmail: function(newValue) {
      if (this.isMounted) {
        this.$refs.repeatEmailField.setValidationRegex("^" + newValue + "$");
      }
    },
  },
  mounted: function(){
    this.isMounted = true;
    this.$store.dispatch("subscriber/refreshSubscriberData", this.$http);
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.newEmailField.isValidBeforeSubmit()
        && this.$refs.repeatEmailField.isValidBeforeSubmit();
      return isValid;
    },
    submitForm: function() {
      if (!this.inProgress && this.isFormValid()) {
        this.inProgress = true;
        const subscriberEmailChangeRequest = {
          email: this.$refs.newEmailField.getFieldValue(),
        };
        this.$http.post('api/user/emailChange', subscriberEmailChangeRequest)
          .then(() => {
            this.processSuccessfulCallResponse();
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
          })
          .finally( () => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
      this.$store.commit("setSuccessMessage", this.$i18n.t('EMAIL_CHANGE.SUCCESS'));
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Email change',label: 'Success', value: 0, noninteraction: false });
      this.$router.push({name: 'manage'});
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Email change',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$refs.newEmailField.setValidationErrorAndScroll(this.$i18n.t('COMMON.ERROR_MESSAGES.EMAIL_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Email change',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Email change',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Email change',label: 'Error - '+responseCode, value: 0, noninteraction: false });
        }
    },
  },
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
